import React from "react";

function UpdatePnr() {
  return <div>UpdatePnr</div>;
}

export default UpdatePnr;
